<template>
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择产线工序"
      width="80%"
      top="5vh">
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        hide-show-hide-btn
        url="workLineInfoes">
      <template #adSearch>
        <div class="vm-search">
          <vm-search label="产线名称">
            <el-input v-model.trim="filter.cname" clearable/>
          </vm-search>
          <vm-search label="编号">
            <el-input v-model.trim="filter.code" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="55"/>
      <el-table-column prop="cname" align="center" label="产线名称"/>
      <el-table-column prop="code" align="center" label="编号"/>
      <el-table-column prop="addDate" align="center" label="添加日期"/>
      <el-table-column prop="productGroupNO" align="center" label="产品组" width="100"/>
      <el-table-column prop="purchaseGroupNO" align="center" label="采购组" width="100"/>
      <el-table-column prop="configurableFlagDesc" width="80" align="center" label="可配置物料"/>
      <el-table-column label="操作" align="center" width="120px">
        <template v-slot="scope">
          <el-button size="mini" type="success" @click="onSelect(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "WorkLineInfoSelect",
    components: {VmTable,VmSearch},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        showNoIdMaterial:false,
        idList: "",
        filter: {
          cname: "",
          code: "",
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.showNoIdMaterial=false;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },

      selectNoIdMaterial() {
        let NoIdMaterial = {
          id: -1,
          name: "无料号",
          no: "无料号",
          price: "",
          unit: "",
        };
        if(this.showNoIdMaterial) {
          console.log(this.$refs.vmTable);
          this.$refs.vmTable._data.tableData = [];
          this.$refs.vmTable._data.tableData.push(NoIdMaterial);
        }else{
          this.$refs.vmTable.getList(1);
        }
      },
      onSelect(row) {
        //获取单个数据
        console.log(row);
        this.$http
          .get("basic", `workLineInfoes/${row.pkid}`)
          .then(resp => {
            console.log(resp);
            this.$emit("select", resp);
            this.dialogVisible = false;
          });

      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
